export default "__VITE_ASSET__odHrEQpX__"